module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5741924f2937233d3f0c8ef61b5905bc.png";